import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);
const API = process.env.REACT_APP_API_URL || 'https://api.ulitar.com';
const host = () => typeof window !== 'undefined' ? window.location.hostname : '';
const mkHeaders = (token, extra = {}) => ({
  'Content-Type': 'application/json',
  'X-Store-Host': host(),
  'X-Platform': 'ulitar',
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
  ...extra,
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = localStorage.getItem('ulitar_token');
    const u = localStorage.getItem('ulitar_user');
    if (t && u) { setToken(t); try { setUser(JSON.parse(u)); } catch {} }
  }, []);

  const save = (t, u) => {
    setToken(t); setUser(u);
    localStorage.setItem('ulitar_token', t);
    localStorage.setItem('ulitar_user', JSON.stringify(u));
  };

  const login = async (email, password) => {
    try {
      const r = await fetch(`${API}/api/user/login`, { method: 'POST', headers: mkHeaders(null), body: JSON.stringify({ email, password }) });
      const d = await r.json();
      const t = d.token || d.accessToken;
      if (t) { save(t, d.user || d.data); return { success: true }; }
      return { success: false, message: d.message || 'Login failed' };
    } catch { return { success: false, message: 'Network error' }; }
  };

  const register = async (name, email, password) => {
    try {
      const r = await fetch(`${API}/api/user/signup`, { method: 'POST', headers: mkHeaders(null), body: JSON.stringify({ name, email, password }) });
      const d = await r.json();
      const t = d.token || d.accessToken;
      if (t) { save(t, d.user || d.data); return { success: true }; }
      return { success: false, message: d.message || 'Registration failed' };
    } catch { return { success: false, message: 'Network error' }; }
  };

  const logout = () => {
    setToken(null); setUser(null);
    localStorage.removeItem('ulitar_token');
    localStorage.removeItem('ulitar_user');
  };

  const apiHeaders = (extra = {}) => mkHeaders(token, extra);

  return (
    <AuthContext.Provider value={{ user, token, isLoggedIn: !!token, login, register, logout, apiHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
